// Itens de menu da aplicação.
//
// Ficam fora do Sidebar porque o cabeçalho também precisa deles: o nome da tela
// mostrado lá é derivado da rota atual. Antes ele vinha só do `updateMenu` que
// cada página chamava ao montar, e a tela que esquecia de chamar (Configurações,
// por exemplo) herdava em silêncio o nome da tela anterior — o cabeçalho dizia
// "Portfólio" com Configurações aberta.

export const menuItems = [
    { name: "Início", icon: "/images/icon/home.png", to: "/dashboard" },
    { name: "Clientes", icon: "/images/icon/menu-clientes.png", to: "/clientes" },
    { name: "Licitações e Editais", icon: "/images/icon/file-check.png", to: "/editais" },
    { name: "ATA", icon: "/images/icon/files.png", to: "/atas" },
    { name: "Contratos", icon: "/images/icon/file-signature.png", to: "/contratos" },
    { name: "Orçamentos Prestadores", icon: "/images/icon/orcamento.png", to: "/orcamentosprestadores" },
    { name: "Empenhos", icon: "/images/icon/dollar-sign.png", to: "/orcamentos" },
    { name: "Contas a Receber", icon: "/images/icon/contas-receber.png", to: "/contasreceber" },
    { name: "Impostos", icon: "/images/icon/menu-impostos.png", to: "/impostos" },
    { name: "Despesas", icon: "/images/icon/dollar-sign.png", to: "/despesas", permission: "VISUALIZAR_DESPESA" },
    { name: "Notas de Materiais", icon: "/images/icon/sticker.png", to: "/notasfiscais" },
    { name: "Notas de Serviços", icon: "/images/icon/nfse.png", to: "/notasfiscaisservicos" },
    { name: "Boletos", icon: "/images/icon/boleto.png", to: "/boletos" },
    { name: "Fornecedores", icon: "/images/icon/truck.png", to: "/fornecedores" },
    { name: "Pedidos de Compra", icon: "/images/icon/files.png", to: "/pedidos-compra" },
    { name: "Gestão de Obras", icon: "/images/icon/hammer.png", to: "/obras" },
    { name: "Patrimônio", icon: "/images/icon/tv-2.png", to: "/patrimonios", permission: "VISUALIZAR_PATRIMONIO" },
    { name: "Documentos", icon: "/images/icon/folder-open.png", to: "/documentos" },
    { name: "Portfólio", icon: "/images/icon/tv-2.png", to: "/portfolio" },
    { name: "Relatórios", icon: "/images/icon/line-chart.png", to: "/relatorios", permission: "VISUALIZAR_RELATORIOS" },
    { name: "Compliance", icon: "/images/icon/line-chart.png", to: "/compliance", permission: "VISUALIZAR_COMPLIANCE" },
];

// Itens após a linha de separação
export const secondaryMenuItems = [
    { name: "Alertas", icon: "/images/icon/bell.png", to: "/alertas" },
    { name: "Configurações", icon: "/images/icon/settings.png", to: "/configuracoes" },
];

/**
 * Item de menu correspondente a um caminho.
 *
 * Casa pelo prefixo mais longo, para que as sub-rotas fiquem sob o item certo
 * (/despesas/editar/7 -> "Despesas", /configuracoes/menus -> "Configurações").
 * Devolve null quando nada casa, e aí quem chamou decide o que exibir.
 */
export const menuItemPorRota = (pathname) => {
    if (!pathname) return null;

    return [...menuItems, ...secondaryMenuItems]
        .filter((item) => pathname === item.to || pathname.startsWith(`${item.to}/`))
        .sort((a, b) => b.to.length - a.to.length)[0] || null;
};
